// removed by extract-text-webpack-plugin
module.exports = {"postTitle":"_15D942kQmYU_BckZe59zPU","featuredArticleLabel":"_1-M8gs3z6lZzz4TdIYhaRD","relatedPosts":"_3ycVuc5MkjXgwjTCZ2qPC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/blog-post/BlogPost.css
// module id = 558
// module chunks = 0